import { isEmpty } from 'lodash/lang'

export default {
  /* To show/hide the reset button for a specific device */
  devices_filled () {
    return this.devices.map(device => {
      let filled = !isEmpty(device.brand) || !isEmpty(device.model) || !isEmpty(device.model_code) || device.chosenCategory?.is_leaf || !isEmpty(device.purchase_date) || !isEmpty(device.purchase_price) || !isEmpty(device.serialNumber)
      switch (this.productType) {
        case this.productTypes.INSURANCE:
          filled |= !isEmpty(device.imei)
          break
        case this.productTypes.OUT_WARRANTY:
          filled |= !isEmpty(device.incidentDate) || !isEmpty(device.incidentDescription)
      }
      return filled
    })
  },

  /* To show/hide the reset button */
  is_devices_filled () {
    return this.devices_filled.some(isDeviceFilled => isDeviceFilled)
  },

  devicesWithPurchasePriceConverted () {
    return this.devices.map(function (device) {
      if (typeof device.purchase_price === 'number' || device.purchase_price === '') return device
      device = { ...device }
      const strPrice = device.purchase_price

      const numPrice = parseFloat(strPrice.replace(',', '.'))

      device.purchase_price = numPrice
      return device
    })
  },

  devicesWithBrand () {
    return this.devicesWithPurchasePriceConverted.map(device => {
      if (device.brand !== '') {
        const brand = this.data_device.brands
          .find(brand => brand.full_name.toLowerCase() === device.brand.toLowerCase())
        device.brand_id = brand === undefined ? null : brand.id
      }
      return device
    })
  },

  lastDevice () {
    return this.devices[this.devices.length - 1]
  },

  currentDevice: {
    get () {
      return this.devices[this.currentDeviceIndex]
    },
    set (device) {
      this.$set(this.devices, this.currentDeviceIndex, device)
    }
  },

  canDeleteAllDevices () {
    switch (this.productType) {
      case this.productTypes.INSURANCE:
        return this.devices.length > 1 && (this.devices.length > this.chosenOffer.min_devices || this.lastDeviceIsAPack)
      case this.productTypes.WARRANTY_EXTENSION:
        return this.devices.length > 1
      default:
        return false
    }
  }
}
